<template >
  <div class="container profile-page">
<section class="section">
      <div class="container">
        <div class="card card-profile shadow mt--300">
          <div class="px-4">
            <div class="row justify-content-center">
              <div class="col-lg-3 order-lg-2">
                <div class="card-profile-image">
                  <a href="javascript:;">
                    <img src="/assets/img/team-4.jpg" class="rounded-circle">
                  </a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-3 text-lg-right align-self-lg-center">
                <div class="card-profile-actions py-4 mt-lg-0">
                  <a href="#" class="btn btn-sm btn-info mr-4">Connect {{currentUser.email}}</a>
                  <a href="#" class="btn btn-sm btn-default float-right">Message</a>
                </div>
              </div>
              <div class="col-lg-4 order-lg-1">
                <div class="card-profile-stats d-flex justify-content-center">
                  <div>
                    <span class="heading">22</span>
                    <span class="description">Friends</span>
                  </div>
                  <div>
                    <span class="heading">10</span>
                    <span class="description">Photos</span>
                  </div>
                  <div>
                    <span class="heading">89</span>
                    <span class="description">Comments</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mt-5">
              <h3> {{customerData.email}}<span class="font-weight-light">, 27</span></h3>
              <div class="h6 font-weight-300"><i class="ni location_pin mr-2"></i>Firstname, Lastname</div>
              <div class="h6 mt-4"><i class="ni business_briefcase-24 mr-2"></i>Teacher</div>
              <div><i class="ni education_hat mr-2"></i>Surguuli</div>
            </div>
            <div class="mt-5 py-5 border-top text-center">
              <div class="row justify-content-center">
                <div class="col-lg-9">
                  <p></p>
                  <a href="javascript:;"> {{}}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";
const fb = require("../../firebaseConfig.js");

export default {
  name: "UserProfile",
  data() {
    return {
      customerData: {
        name:null,
        lastname:null,
        email:null,
        phone:null,
        description:null
      },
      schools:[],
      school:null,
      department:null,
      program:null

    };
  },
  computed: {
    ...mapState(["currentUser", "enabled", "userProfile", "school"])
  },
  async created() {
    var _this=this;
      if(this.userProfile && this.userProfile.customer){
        this.userProfile.customer.get().then(doc=>{
          let data=doc.data();
          data.id=doc.id;
          data.ref=doc.ref;
          _this.customerData.email = data.email;
        })}
  },
  methods: {
    async saveProfile(){
      if (this.currentUser != null) {
        if(this.userProfile.customer!=null){
          // if(this.school!=null && this.school!=undefined && this.school.id!=null){
          //   this.loginForm.school=fb.db.collection("schools").doc(this.school.id);
          //   if(this.department!=null && this.department!=undefined && this.department.id!=null){
          //     this.loginForm.department=fb.db.collection("schools").doc(this.school.id).collection("departments").doc(this.department.id);
          //     if(this.userProfile!=null && this.userProfile.role=="teacher")
          //       this.loginForm.schoolSelected=true;
          //     else if(this.userProfile!=null && this.userProfile.role=="student"){
          //       if(this.program!=null && this.program!=undefined && this.program.id!=null){
          //         this.loginForm.program=fb.db.doc("schools/"+this.school.id+"/departments/"+this.department.id+"/programs/"+this.program.id);
          //         this.loginForm.schoolSelected=true;
          //       }
          //     }
          //   }
            
          // }

          this.userProfile.customer.update(this.loginForm);
          this.$router.back();
        }
      }
    },
    async getSchools(){
      var schoolsData=await fb.db.collection("schools").get()
      if(!schoolsData.empty){
        for (const schoolSnp of schoolsData.docs) {
          let object=schoolSnp.data();
          object.id=schoolSnp.id;
          object.departments=[];
          this.getDepartments(object, schoolSnp.ref);
          this.schools.push(object);

          if(this.loginForm.school!=null && this.loginForm.school!=undefined && this.loginForm.school.id!=null && this.loginForm.school.id==object.id)
            this.school=object;
          
        }
      }
     
    },
    async getDepartments(school, schoolRef){
      var departmentData=await fb.db.collection("schools/"+school.id+"/departments").get()
      if(!departmentData.empty){
        for (const depSnp of departmentData.docs) {
          let object=depSnp.data();
          object.id=depSnp.id;
          object.programs=[];
          this.getPrograms(school, object, depSnp.ref);
          school.departments.push(object);
          if(this.loginForm.department!=null && this.loginForm.department!=undefined && this.loginForm.department.id!=null && this.loginForm.department.id==object.id)
          { 
            this.department=object;
          }
        }
      }
     
    },
    async getPrograms(school, department, departmentRef){
      var programsData=await fb.db.collection("schools/"+school.id+"/departments/"+department.id+"/programs").get()
      if(!programsData.empty){
        for (const programSnp of programsData.docs) {
          let object=programSnp.data();
          object.id=programSnp.id;
          department.programs.push(object);
          if(this.loginForm.program!=null && this.loginForm.program!=undefined && this.loginForm.program.id!=null && this.loginForm.program.id==object.id)
            this.program=object;
        }
      }
     
    }

   
  }
};
</script>

<style scoped>
.profile-page .card-profile .card-profile-image {
    position: relative;
}
.profile-page .card-profile .card-profile-image img {
    max-width: 180px;
    border-radius: 0.25rem;
    transform: translate(-50%, -30%);
    position: absolute;
    left: 50%;
    transition: all 0.15s ease;
}

.shadow, .profile-page .card-profile .card-profile-image img {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07) !important;
}
.rounded-circle {
    border-radius: 50% !important;
}

img {
    vertical-align: middle;
    border-style: none;
}
*, *::before, *::after {
    box-sizing: border-box;
}
 
[class*="shadow"] {
    transition: all 0.15s ease;
}
.shadow, .profile-page .card-profile .card-profile-image img {
    box-shadow: 0 15px 35px rgba(50, 50, 93, 0.1), 0 5px 15px rgba(0, 0, 0, 0.07) !important;
}

.card {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: border-box;
    border: 0.0625rem solid rgba(0, 0, 0, 0.05);
    border-radius: 0.25rem;
}
@media (min-width: 992px){
.order-lg-2 {
    order: 2;
}
}
@media (min-width: 992px){
.col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
}
}
.profile-page .card-profile .card-profile-stats {
    padding: 1rem 0;
}

.justify-content-center {
    justify-content: center !important;
}
.d-flex {
    display: flex !important;
}
*, *::before, *::after {
    box-sizing: border-box;
}
.profile-page .card-profile .card-profile-stats>div {
    text-align: center;
    margin-right: 1rem;
    padding: .875rem;
}
.profile-page .card-profile .card-profile-stats>div .heading {
    font-size: 1.1rem;
    font-weight: bold;
    display: block;
}
.heading {
    letter-spacing: 0.025em;
    font-size: 0.95rem;
    text-transform: uppercase;
    font-weight: 400;
}
.profile-page .card-profile .card-profile-stats>div .description {
    font-size: .875rem;
    color: #adb5bd;
}

@media (min-width: 992px){
.text-lg-right {
    text-align: right !important;
}}
@media (min-width: 992px){
.align-self-lg-center {
    align-self: center !important;
}
}

@media (min-width: 992px){
.order-lg-3 {
    order: 3;
}}
@media (min-width: 992px){
.col-lg-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
}
}
@media (min-width: 992px){
.order-lg-1 {
    order: 1;
}
}
@media (min-width: 992px){
.col-lg-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
}}

.profile-page .card-profile .card-profile-actions {
    padding: .875rem;
}

.mr-4, .mx-4 {
    margin-right: 1.5rem !important;
}
a {
    color: #5e72e4;
    text-decoration: none;
    background-color: transparent;
}
.section {
    position: relative;
    padding-top: 4rem;
    padding-bottom: 4rem;
}

p {
    font-size: 1rem;
    font-weight: 300;
    line-height: 1.7;
}
</style>